import { IIconBase } from '..'

const importIcon = ({
  color = '#ffffff',
  height = 17,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/import'>
        <g id='import'>
          <path
            id='Vector'
            d='M6.21338 8.28711L7.92005 9.99378L9.62671 8.28711'
            stroke={color}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M7.91992 3.16699V9.94699'
            stroke={color}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_3'
            d='M13.3334 8.62012C13.3334 11.5668 11.3334 13.9535 8.00008 13.9535C4.66675 13.9535 2.66675 11.5668 2.66675 8.62012'
            stroke={color}
            strokeMiterlimit='10'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </svg>
  )
}

export default importIcon
